export const Authorizedmsg = "You are not Authorized";
export const Sessionexpmsg = "Session Timeout.Please Login Again!";
export const ServerError = "Please Check Your Internet!";
export const ApiError = "Please Check with Provider!";
